import { CIcon } from '~/icons/types'

export const ciOpenMail: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M19.05 22.49H5a3.12 3.12 0 0 1-3.12-3.12V9a3.14 3.14 0 0 1 1.43-2.68L10.37 2a3 3 0 0 1 3.26 0l7.06 4.34A3.14 3.14 0 0 1 22.17 9v10.4a3.12 3.12 0 0 1-3.12 3.09Zm-7-19a1.12 1.12 0 0 0-.58.17L4.36 8a1.11 1.11 0 0 0-.53 1v10.4A1.12 1.12 0 0 0 5 20.49h14.1a1.12 1.12 0 0 0 1.12-1.12V9a1.11 1.11 0 0 0-.53-1l-7-4.34a1.18 1.18 0 0 0-.69-.15l.05-.02ZM12 15a2.76 2.76 0 0 1-1.46-.41l-5.95-3.7a1 1 0 1 1 1.05-1.7l6 3.66a.8.8 0 0 0 .82 0l5.95-3.66a1 1 0 1 1 1.05 1.7l-5.95 3.66A2.76 2.76 0 0 1 12 15Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'open-mail',
  type: 'regular'
}
